(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bulltattoo-purchase-cards"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bt-routine]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-bt-routine-form]');
    const variantInput = root.querySelector('[data-bt-variant]');
    const sellingPlanInput = root.querySelector('[data-bt-selling-plan]');
    const submit = root.querySelector('[data-bt-submit]');
    const frequencyPanel = root.querySelector('[data-bt-frequency-panel]');
    const benefits = root.querySelector('[data-bt-benefits]');
    const subscriptionPrice = root.querySelector('[data-bt-subscription-price]');
    const errorMessage = root.querySelector('[data-bt-error]');
    const page = root.closest('.bt-prod-wrap');
    const mainPrice = page.querySelector('[data-bt-selected-price]');
    const packReference = page.querySelector('[data-bt-pack-reference]');
    const mainFormat = page.querySelector('[data-bt-selected-format]');
    const offerSummary = page.querySelector('.bt-offer-summary');
    const stickyName = page.querySelector('#bt-sticky-name');
    const stickyPrice = page.querySelector('#bt-sticky-price');
    const stickyButton = page.querySelector('#bt-sticky-btn');
    const subscriptionOptions = root.querySelector('[data-bt-subscription-options]');
    const subscriptionSummary = root.querySelector('[data-bt-subscription-summary]');

    if (stickyButton) stickyButton.onclick = () => {
      if (!submit.disabled) form.requestSubmit(submit);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        document.body.classList.toggle('bt-purchase-in-view', entry.isIntersecting);
      }, { rootMargin: '0px 0px 84px 0px' }).observe(root);
    }

    let lastImageChoice;
    function update() {
      const choice = root.querySelector('input[name="bt-purchase-choice"]:checked');
      if (!choice) return;
      root.querySelectorAll('[data-bt-card]').forEach((card) => card.classList.toggle('is-selected', card.contains(choice)));
      if (choice.value !== lastImageChoice) {
        const thumb = page.querySelector(choice.value === 'single' ? '[data-bt-single-image]' : '[data-bt-pack-image]');
        if (thumb && typeof window.btSetImg === 'function') {
          const image = thumb.querySelector('img');
          if (image) window.btSetImg(image.src.replace(/&width=150$/, ''), thumb);
        }
        lastImageChoice = choice.value;
      }
      const subscription = choice.value === 'subscription';
      const frequency = root.querySelector('input[name="bt-subscription-frequency"]:checked');
      const price = choice.value === 'single' ? root.dataset.singlePrice : subscription && frequency ? frequency.dataset.price : root.dataset.bundlePrice;
      const name = choice.value === 'single' ? root.dataset.singleName : subscription ? root.dataset.subscriptionName : root.dataset.bundleName;
      const format = choice.value === 'single' ? root.dataset.singleFormat : subscription ? root.dataset.subscriptionFormat : root.dataset.bundleFormat;
      if (mainPrice) mainPrice.textContent = price;
      if (packReference) packReference.hidden = choice.value !== 'bundle';
      if (mainFormat) mainFormat.textContent = format;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyName) stickyName.textContent = name;
      if (offerSummary) offerSummary.hidden = choice.value !== 'bundle';
      if (subscriptionOptions) subscriptionOptions.open = subscription;
      if (subscriptionSummary) subscriptionSummary.textContent = subscription ? root.dataset.subscriptionSelected : root.dataset.subscriptionToggle;
      if (frequencyPanel) frequencyPanel.hidden = !subscription;
      benefits.hidden = !subscription;

      if (choice.value === 'single') {
        variantInput.value = root.dataset.singleVariantId;
        sellingPlanInput.value = '';
        submit.textContent = root.dataset.singleButton;
      } else if (choice.value === 'bundle') {
        variantInput.value = root.dataset.packVariantId;
        sellingPlanInput.value = '';
        submit.textContent = root.dataset.bundleButton;
      } else {
        variantInput.value = root.dataset.packVariantId;
        sellingPlanInput.value = frequency ? frequency.dataset.sellingPlanId : '';
        submit.textContent = root.dataset.subscriptionButton;
        if (frequency && subscriptionPrice) subscriptionPrice.textContent = frequency.dataset.price;
      }
      if (stickyButton) stickyButton.textContent = submit.textContent;
    }

    root.querySelectorAll('input[name="bt-purchase-choice"], input[name="bt-subscription-frequency"]').forEach((input) => input.addEventListener('change', update));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const choice = root.querySelector('input[name="bt-purchase-choice"]:checked');
      const frequency = root.querySelector('input[name="bt-subscription-frequency"]:checked');
      const variantId = choice && choice.value === 'single' ? root.dataset.singleVariantId : root.dataset.packVariantId;
      const sellingPlanId = choice && choice.value === 'subscription' && frequency ? frequency.dataset.sellingPlanId : '';
      if (!choice || !variantId || choice.value === 'subscription' && !sellingPlanId) return;

      const cartRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (sellingPlanId) body.append('selling_plan', sellingPlanId);

      submit.disabled = true;
      if (errorMessage) errorMessage.hidden = true;
      try {
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || result.message);
        }
        window.location.assign(`${cartRoot}cart`);
      } catch (error) {
        submit.disabled = false;
        if (errorMessage) {
          errorMessage.textContent = error.message;
          errorMessage.hidden = false;
        }
      }
    }, true);
    update();
  });
  } catch(e) { console.error(e); }
})();

})();
